import script from "./labelText.vue?vue&type=script&lang=js"
export * from "./labelText.vue?vue&type=script&lang=js"

import "./labelText.vue?vue&type=style&index=0&id=03227db6&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03227db6"]])

export default __exports__